(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["j-artwork-product-inquiry"] && !Shopify.designMode) return;
  try {
    if (!window.__jaRequestPhotosBound) {
    window.__jaRequestPhotosBound = true;
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-ja-request-photos]');
      if (!trigger) return;

      const inquiry = document.querySelector('#artwork-inquiry');
      if (!inquiry) return;

      event.preventDefault();
      const details = inquiry.querySelector('details');
      if (details) details.open = true;

      const typeInput = inquiry.querySelector('[data-ja-inquiry-type]');
      if (typeInput) typeInput.value = 'Request more photos';

      const message = inquiry.querySelector('textarea[name="contact[body]"]');
      if (message && !message.value.trim()) {
        message.value = 'Hi, I’m interested in this artwork. Could you please send me a few more photos, including close-up details and an angle showing the texture/edges?';
      }

      inquiry.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(function () {
        const nameInput = inquiry.querySelector('input[name="contact[name]"]');
        if (nameInput) nameInput.focus({ preventScroll: true });
      }, 450);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
